import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SettingsState {
  slippageBps: number
  deadlineMinutes: number
  setSlippageBps: (v: number) => void
  setDeadlineMinutes: (v: number) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      slippageBps: 50,
      deadlineMinutes: 20,
      setSlippageBps: (slippageBps: number) => set({ slippageBps }),
      setDeadlineMinutes: (deadlineMinutes: number) => set({ deadlineMinutes }),
    }),
    { name: 'kavachswap-settings-v1' },
  ),
)